import { getRandomTailwindColor } from "@/utils/tailwindColors";

import type { NodeJson } from "@corca/data";

export const themeSelector: NodeJson[] = [
  {
    type: "variable",
    props: {
      color: getRandomTailwindColor("x"),
    },
    children: [
      {
        type: "symbol",
        props: { value: "x" },
        children: [],
      },
    ],
  },
  {
    type: "variable",
    props: {
      color: getRandomTailwindColor("E"),
    },
    children: [
      {
        type: "symbol",
        props: { value: "E" },
        children: [],
      },
    ],
  },
  {
    type: "number",
    props: {
      value: "2",
    },
    children: [],
  },
];
